import React from "react";
import "@/App.css";
import { Routes, Route } from "react-router-dom";

import AdminApp from "./admin/AdminApp";
import PublicSiteGate from "./components/PublicSiteGate";

export default function App() {
  return (
    <Routes>
      <Route path="/admin/*" element={<AdminApp />} />
      <Route path="/*" element={<PublicSiteGate />} />
    </Routes>
  );
}
